module.exports = __webpack_public_path__ + "img/img3.c66d198e.jpg";